import { useEffect } from 'react';

import { Box, LoadingOverlay, noop } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { useGetPersonSettingsById } from '@/entities/Settings';
import { WorkTimeSelector } from '@/entities/WorkTimeSelector/WorkTimeSelector.tsx';

import { LocationSelectorSheet } from '@/features/LocationSelectorSheet';

import { normalizeWorkTime } from '@/shared/helpers/workTime.ts';
import { DesktopLayout } from '@/shared/layouts/DesktopLayout.tsx';
import useAppStore from '@/shared/store/app.store.ts';
import { useSettingsStore } from '@/shared/store/settings.store.ts';
import useUserStore from '@/shared/store/user.store.ts';

export const InitSettings = () => {
	const isMobile = useAppStore((state) => state.isMobile);
	const userId = useUserStore((state) => state.user?.id);
	const targetPersonId = useUserStore((state) => state.targetPersonId);
	const sessionPersonId = useUserStore((state) => state.session?.user?.person_id);
	const personId = userId ?? targetPersonId ?? sessionPersonId ?? undefined;
	const workTime = useSettingsStore((state) => state.workTime);
	const location = useSettingsStore((state) => state.location);
	const updateSettingsStore = useSettingsStore((state) => state.updateState);
	const [opened] = useDisclosure(true);

	const { personSettings, isLoadingPersonSettings, isLoadingPersonSettingsError } =
		useGetPersonSettingsById(personId);

	useEffect(() => {
		if (personSettings) {
			const { work_time, car_number, current_location, location } = personSettings.settings;
			const formatData = {
				id: personSettings?.id,
				workTime: normalizeWorkTime(JSON.parse(work_time ?? 'null')),
				carNumber: JSON.parse(car_number ?? 'null'),
				location: JSON.parse(location ?? 'null'),
				currentLocation: JSON.parse(current_location ?? 'null'),
			};

			try {
				updateSettingsStore(formatData);
			} catch (error) {
				console.error(error);
			}
		}
	}, [personSettings]);

	if (!personId || isLoadingPersonSettings)
		return (
			<Box pos="relative" h="100dvh" w="100dvw">
				<LoadingOverlay visible />
			</Box>
		);

	if (!workTime)
		return (
			<>
				{!isMobile && <DesktopLayout leftSlot={<></>} rightSlot={<></>} />}
				<WorkTimeSelector opened={opened} onClose={noop} />
			</>
		);

	if (!location)
		return (
			<>
				{!isMobile && <DesktopLayout leftSlot={<></>} rightSlot={<></>} />}
				<LocationSelectorSheet title="Локация" close={() => false} />
			</>
		);
};
